<template>
  <div class="r-order-add">
    <!-- <div class="status common-hover" @click="changeTip"><div>Tip name</div></div> -->
    <div class="common-flex common-justify-between common-align-center">
      <Checkbox v-model="config.check"></Checkbox>
      <div style="margin:0 30px 0 10px">{{index+1}}</div>
      <div class="product">
        <img :src="config.clothPath" alt="" />
        <div class="product-name">
          <div>{{config.orderType}}</div>
        </div>
      </div>

      <div
        class="product-code common-flex common-direction-column common-justify-center"
      >
        <div class="code">{{ config.orderCode }}</div>
        <div class="attr"><span v-if="config.clothCategoryName">{{ config.clothCategoryName }} |</span>
          <span v-if="config.fabric">{{ config.fabric }} | </span
          >Qty:{{ config.amount }}
        </div>
        <!-- <div class="details"> <span class="common-hover" @click="details">Details</span>  | <span class="common-hover" @click="urgent">urgent</span> | <span class="common-hover" @click="cancel">Cancel</span> </div> -->
      </div>

      <div class="product-cate common-justify-center common-flex common-align-center">
        <Tooltip :content="config.sizeCategoryName" placement="top">
          <div v-if="config.sizeCategoryId==10054" class="iconfont iconbiaozhunhao"></div>
          <div v-if="config.sizeCategoryId==10053" class="iconfont iconchengyi"></div>
          <div v-if="config.sizeCategoryId==10052" class="iconfont iconjingti"></div>
        </Tooltip>
        <div>{{ config.customerName ||'' }}</div>
      </div>
      <div class="product-total"><span>{{config.pubDate ? config.pubDate : '--' }} </span>  </div>
      <div class="product-total"><span>{{config.inDate ? config.inDate:  '--'}}</span></div>
      <div class="product-total"><span>{{config.deliveryDate ? config.deliveryDate: '--'}}</span></div>
      <!-- <div class="product-total">{{config.price}} x {{config.amount}}</div>

      <div class="product-price">{{config.price*config.amount}}</div> -->
      <!-- <div class="product-status common-flex common-align-center common-justify-center">
        <div class="radio"></div>
        <div>Product</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "r-order-add",
  data() {
    return {
      check:false
    };
  },
  props:{
    config:Object,
    index:Number
  },
  methods:{
    changeChoose(){
      this.$emit('changeChoose')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-order-add {
  width: 1140px;
  margin: 0 auto;
  padding: 20px 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  // .status {
  //   width: 52px;
  //   height: 20px;
  //   line-height: 20px;
  //   background: #fbf1e6;
  //   font-size: 10px;
  //   font-weight: 400;
  //   text-align: right;
  //   color: #d87508;
  //   position: relative;
  //   > div {
  //     transform: scale(0.83);
  //   }
  // }
  .status::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 20px solid #fbf1e6;
    border-right: 20px solid transparent;
    right: -20px;
    top: 0;
  }
  .product {
    width: 76px;
    height: 76px;
    position: relative;
    margin-right: 15px;
    img {
      width: 76px;
      height: 76px;
    }
  }
  .product-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 76px;
    height: 15px;
    line-height: 15px;
    background: rgba(8, 25, 56, 0.5);
    color: #fff;
    text-align: center;

    > div {
      font-size: 12px;
      transform: scale(0.83);
    }
  }
  .product-code {
    width: 310px;
    text-align: left;
    .code {
      font-size: 14px;
      font-weight: 600;
      color: #081938;
      line-height: 16px;
    }
    .attr {
      font-size: 12px;
      font-weight: 400;
      color: #081938;
      line-height: 14px;
      margin: 5px 0;
    }
    .details {
      font-size: 12px;
      font-weight: 400;
      text-decoration: underline;
      color: #0a4dcc;
      line-height: 14px;
    }
  }
  .product-cate {
    width: 261px;
    opacity: 1;
    font-size: 14px;
    font-family: Roboto, Roboto-Condensed;
    font-weight: Condensed;
    // text-align: left;
    color: #081938;
    line-height: 16px;
    letter-spacing: 1px;
    .iconjacket {
      margin-right: 9px;
    }
  }
  .product-total {
    width: 400px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 16px;
  }
  .product-price {
    width: 246px;
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    color: #081938;
    line-height: 16px;
  }
  .product-status {
    width: 200px;
    text-align: right;
    color: #0a4dcc;
    .radio {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #0a4dcc;
      margin-right: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-order-add.vue